import { createTheme } from "@mui/material";

const handleLightTheme = () => {
  const LightTheme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "--TextField-brandBorderColor": "#a9a9a9",
            "--TextField-brandBorderHoverColor": "#a9a9a9",
            "--TextField-brandBorderFocusedColor": "#a9a9a9",
            "& label.Mui-focused": {
              color: "var(--TextField-brandBorderFocusedColor)",
            },
            "& .MuiInput-outlined:before": {
              borderBottomColor: "#a9a9a9", // Cor da linha padrão
            },
            "& .MuiInput-outlined:hover:not(.Mui-disabled):before": {
              borderBottomColor: "#a9a9a9", // Cor da linha no hover
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#a9a9a9", // Cor da borda para variant="outlined"
              },
              "&:hover fieldset": {
                borderColor: "#a9a9a9", // Cor da borda no hover
              },
              "&.Mui-focused fieldset": {
                borderColor: "#a9a9a9", // Cor da borda ao focar
              },
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: "8px",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
          },
        },
      },
    },
    palette: {
      mode: "light",
      primary: {
        main: "#4c91fffb",
      },
      action: {
        disabled: "#6b78898d",
      },
    },
  });

  return [LightTheme];
};

export { handleLightTheme };
